<template>
  <div class="admin-tab-content">
    <div class="tab-header">
      <h2>💬 Configuración Zopim Chat</h2>
      <p class="description">Configura el modo de visualización del widget de chat Zopim</p>
    </div>

    <div class="control-section">
      <label for="zopim-mode">Modo de Visualización:</label>
      <select id="zopim-mode" v-model="zopimDisplaySetting" class="admin-select">
        <option :value="0">Flotante (Widget estándar)</option>
        <option :value="1">Icono en el menú lateral</option>
        <option :value="2">Ambos (Flotante + Menú)</option>
      </select>
      <p class="help-text">
        Seleccione cómo se mostrará el chat Zopim:<br>
        - <strong>Flotante</strong>: Widget tradicional en la esquina de la pantalla<br>
        - <strong>Menú</strong>: Icono en el menú lateral que abre el chat<br>
        - <strong>Ambos</strong>: Widget flotante y icono en el menú simultáneamente
      </p>
    </div>

    <div class="action-section">
      <button @click="saveSettings" class="btn-primary" :disabled="saving">
        {{ saving ? 'Guardando...' : 'Guardar Configuración' }}
      </button>
    </div>

    <div v-if="message" :class="['message-box', messageType]">
      {{ message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ZopimSettingsTab',
  data() {
    return {
      zopimDisplaySetting: 0,
      saving: false,
      message: '',
      messageType: ''
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/zopim-display-setting`);
        if (response.data.success) {
          this.zopimDisplaySetting = parseInt(response.data.value);
        }
      } catch (error) {
        console.error('Error loading zopim display settings:', error);
      }
    },
    async saveSettings() {
      this.saving = true;
      this.message = '';

      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/zopim-display-setting/${this.zopimDisplaySetting}`);

        if (response.data.success) {
          this.message = 'Configuración guardada correctamente. Los cambios se aplicarán cuando los usuarios recarguen la página.';
          this.messageType = 'success';

          setTimeout(() => {
            this.message = '';
          }, 5000);
        } else {
          this.message = response.data.message || 'Error al guardar la configuración';
          this.messageType = 'error';
        }
      } catch (error) {
        this.message = 'Error al guardar la configuración';
        this.messageType = 'error';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.admin-tab-content {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.control-section {
  margin-bottom: 20px;
}

.control-section label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #e6e6e6;
}

.admin-select {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
  width: 100%;
  max-width: 400px;
}

.help-text {
  color: #aaa;
  font-size: 13px;
  margin-top: 10px;
  line-height: 1.6;
}

.help-text strong {
  color: #3498db;
}

.action-section {
  margin-top: 20px;
}

.btn-primary {
  background: #3498db;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 20px;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #2980b9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message-box {
  background-color: #333;
  border-radius: 4px;
  margin-top: 15px;
  padding: 10px;
  border-left: 3px solid #3498db;
}

.message-box.success {
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.message-box.error {
  border-left-color: #e74c3c;
  color: #e74c3c;
}
</style>

